import { render } from "./TopicMemberRoleDetailVx.vue?vue&type=template&id=02a65186"
import script from "./TopicMemberRoleDetailVx.vue?vue&type=script&lang=js"
export * from "./TopicMemberRoleDetailVx.vue?vue&type=script&lang=js"

import "./TopicMemberRoleDetailVx.vue?vue&type=style&index=0&id=02a65186&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__